import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { App } from "./App";
import { BookingPage } from "./pages/BookingPage";
import { MedspaBookingPage } from "./pages/MedspaBookingPage";
import { ShopPage } from "./pages/ShopPage";
import "./globals.css";

/**
 * Routing trees:
 *   /booking     — public med-spa self-booking (service menu), NO auth gate
 *   /shop        — public web shop (retail products), NO auth gate
 *   /book/:slug  — legacy calendar booking page, NO auth gate
 *   everything else — wrapped in AuthGate (SyncSuite iframe identity)
 */
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/booking" element={<MedspaBookingPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/book/:slug" element={<BookingPage />} />
        <Route path="/*" element={<AuthGate><App /></AuthGate>} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
